import { render, staticRenderFns } from "./IntelligentIdentificationInfoDialog.vue?vue&type=template&id=1285438b"
import script from "./IntelligentIdentificationInfoDialog.vue?vue&type=script&lang=js"
export * from "./IntelligentIdentificationInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./IntelligentIdentificationInfoDialog.vue?vue&type=style&index=0&id=1285438b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports